import React from 'react'

import { FormFieldStatus, InputField } from '@gousto-internal/citrus-react'
// eslint-disable-next-line @library/dependency-radar/valid-imports
import { Field, FieldProps } from 'formik'

export const HouseNoInput = () => (
  <Field name="houseNo">
    {({ field, meta }: FieldProps) => (
      <InputField
        id={field.name}
        data-testid="houseNo"
        label="House number or name"
        status={meta.touched && meta.error ? FormFieldStatus.Error : undefined}
        validationMessage={meta.touched ? meta.error : undefined}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...field}
      />
    )}
  </Field>
)
